package com.appsyde.shared.app.presentation.tickets

import com.appsyde.shared.modules.ai.domain.model.AiExtractV2
import com.appsyde.shared.modules.ticket.domain.model.Ticket

data class TicketsListState(
    val openTickets: List<Ticket> = emptyList(),
    val waitingTickets: List<Ticket> = emptyList(),
    val closedTickets: List<Ticket> = emptyList(),
    val isLoading: Boolean = false,
    /** Extract par ticketId pour afficher le titre "extract" (aligné Respond) sur chaque ligne. */
    val extractByTicketId: Map<String, AiExtractV2> = emptyMap(),
    /**
     * True when the initial "first screen" load is done (list fetched; extracts come from API + polling).
     * Used by Main to hide the loading screen and show the app (Tickets as first tab).
     */
    val initialLoadDone: Boolean = false
)
